module.exports = __webpack_public_path__ + "img/selectedOrg.9829b73e.svg";